/**
 * API functions for SyntheticTranche entity.
 */
import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type {
    FetchRequest,
    SyntheticTranche,
    SyntheticTrancheInput,
    UUID,
    WaterfallItemInput
} from "../base/ui_general/GeneralInterfaces";

/**
 * Creates a FetchRequest object for creating a new synthetic tranche, including both the synthetic tranche and its associated waterfall item.
 * @param syntheticTrancheInput An object of type SyntheticTrancheInput containing the input data for creating the synthetic tranche.
 * @param waterfallItemInput An object of type WaterfallItemInput containing the input data for the associated waterfall item.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_create_synthetic_tranche(syntheticTrancheInput: SyntheticTrancheInput, waterfallItemInput: WaterfallItemInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_TRANCHE,
        method: HttpMethods.POST,
        query_parameters: {},
        body: {
            waterfall_item: waterfallItemInput,
            synthetic_tranche: syntheticTrancheInput
        },
    }
}

export function getRequest_update_synthetic_tranche(syntheticTranche: SyntheticTranche): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_TRANCHE,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: syntheticTranche,
    };
}

export function getRequest_get_all_synthetic_tranches(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_TRANCHE,
        method: HttpMethods.GET,
        query_parameters: { transaction_id },
    };
}
